import {CustomerType} from "../live/live.config";

export const ReportMenu: REPORTMEUSCONFIG = [
  {
    header: "Performance Reports",
    description: "",
    order: 4,
    menus: [
      {
        icon: "",
        menu: "Distance",
        menu_description:
          "Total miles/kilometers traveled by the vehicle over a specified time period, providing insights into usage patterns and maintenance needs.",
        url: "/api/reports/distance/v2",
        method: "POST",
        filters: ["date", "vehicle"],
        columns: [
          {
            uid: "vehicleName",
            name: "Vehicle/Name"
          }
        ],
        activeColumns: ["vehicleName"],
        headerSidebar: [
          {
            type: "card",
            api_url: [""],
            menu: "distanceHeader",
            sidebarHeading: ""
          }
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE,
          CustomerType.SME
        ]
      },

      {
        icon: "",
        menu: "Speed",
        menu_description:
          "Average and maximum velocity at which the vehicle travels, useful for analyzing driving behavior and compliance with speed regulations",
        url: "/api/reports/speed/v2",
        method: "POST",
        filters: ["date", "vehicle"],
        columns: [
          {
            uid: "vehicleName",
            name: "Vehicle/Name"
          }
        ],
        activeColumns: ["vehicleName"],
        headerSidebar: [
          {
            type: "card",
            api_url: [""],
            menu: "speedHeader",
            sidebarHeading: ""
          }
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE,
          CustomerType.SME
        ]
      },
      {
        icon: "",
        menu: "Trips",
        menu_description:
          "Individual journeys made by the vehicle from start to end points, quantifying frequency of use and typical travel patterns",
        url: "/api/reports/trips/v2",
        method: "POST",
        filters: ["date", "vehicle"],
        columns: [
          {
            uid: "vehicleName",
            name: "Vehicle/Name"
          }
        ],
        activeColumns: ["vehicleName"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      }
    ]
  },
  {
    header: "Bus Attendance Reports",
    description: "",
    order: 1,
    menus: [
      {
        icon: "",
        menu: "Overview",
        menu_description:
          "Overview data on passenger boarding events across the entire bus fleet, tracking card swipes and entry transactions.",
        url: "/api/nextApi/attendanceReport/busAttendace",
        method: "GET",
        filters: ["date"],
        columns: [
          {
            uid: "studentName",
            name: "Student Name"
          },
          {
            uid: "studentClass",
            name: "Class"
          }
        ],
        activeColumns: ["date", "trackerName", "studentName", "studentClass"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "All Bus Swipes",
        menu_description:
          "Comprehensive data on passenger boarding events across the entire bus fleet, tracking card swipes and entry transactions.",
        url: "/api/reports/vehicle/rfidSwipes/v2",
        method: "GET",
        filters: ["date", "vehicle"],
        columns: [
          {
            uid: "date",
            name: "Date"
          },
          {
            uid: "trackerName",
            name: "Bus"
          },
          {
            uid: "studentName",
            name: "Student Name"
          },
          {
            uid: "studentClass",
            name: "Class"
          },
          {
            uid: "rfid",
            name: "Ref. Id/Admission No"
          },
          {
            uid: "onwardPick",
            name: "Onward Pickup"
          },
          {
            uid: "onwardDrop",
            name: "Onward Drop"
          },
          {
            uid: "returnPick",
            name: "Return Pickup"
          },
          {
            uid: "returnDrop",
            name: "Return Drop"
          }
        ],
        activeColumns: [
          "date",
          "trackerName",
          "studentName",
          "studentClass",
          "rfid",
          "onwardPick",
          "onwardDrop",
          "returnPick",
          "returnDrop"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      // {
      //   icon: "",
      //   menu: "Single Bus Swipes",
      //   menu_description:
      //     "Comprehensive data on passenger boarding events across the specific bus fleet, tracking card swipes, and entry transactions.",
      //   url: "/api/reports/vehicle/rfidSwipes/v2",
      //   method: "POST",
      //   filters: ["date", "vehicleSingle"],
      //   columns: [
      //     {
      //       uid: "date",
      //       name: "Date"
      //     },
      //     {
      //       uid: "trackerName",
      //       name: "Bus"
      //     },
      //     {
      //       uid: "studentName",
      //       name: "Student Name"
      //     },
      //     {
      //       uid: "studentClass",
      //       name: "Class"
      //     },
      //     {
      //       uid: "rfid",
      //       name: "Ref. Id/Admission No"
      //     },
      //     {
      //       uid: "onwardPick",
      //       name: "Onward Pickup"
      //     },
      //     {
      //       uid: "onwardDrop",
      //       name: "Onward Drop"
      //     },
      //     {
      //       uid: "returnPick",
      //       name: "Return Pickup"
      //     },
      //     {
      //       uid: "returnDrop",
      //       name: "Return Drop"
      //     }
      //   ],
      //   activeColumns: [
      //     "date",
      //     "trackerName",
      //     "studentName",
      //     "studentClass",
      //     "rfid",
      //     "onwardPick",
      //     "onwardDrop",
      //     "returnPick",
      //     "returnDrop"
      //   ]
      // },
      {
        icon: "",
        menu: "User Swipes",
        menu_description:
          "Number of access control interactions performed by users with assigned RFID cards, tracking entry/exit patterns, and facility usage.",
        url: "/api/reports/user/rfidSwipes/v2",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "userType",
            name: "USER TYPE",
            type: "String"
          },
          {
            uid: "onwardPick",
            name: "ONWARD PICKUP",
            type: "SwipeLocations"
          },
          {
            uid: "onwardDrop",
            name: "ONWARD DROP",
            type: "SwipeLocations"
          },
          {
            uid: "returnPick",
            name: "RETURN PICKUP",
            type: "SwipeLocations"
          },
          {
            uid: "returnDrop",
            name: "RETURN DROP",
            type: "SwipeLocations"
          },
          {
            uid: "otherSwipes",
            name: "OTHER SWIPES",
            type: "SwipeLocations"
          },
          {
            uid: "incompleteSwipe",
            name: "INCOMPLETE SWIPE",
            type: "Boolean"
          }
        ],
        activeColumns: ["date", "studentName", "admissionNo"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]

        // headerSidebar: [
        //   {
        //     type: "card",
        //     api_url: [""],
        //     menu: "rfidUserswipeTopbar",
        //     sidebarHeading: ""
        //   }
        // ]
      }
    ]
  },
  {
    header: "RFID Reports",
    description: "",
    order: 6,
    menus: [
      {
        icon: "",
        menu: "Wrong Swipes",
        menu_description:
          "Identifies and categorizes invalid or mismatched RFID swipes to detect configuration or usage errors.",
        url: "/api/reports/wrongSwipes/v2",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "unassignedSwipes",
            name: "UNASSIGNED VEHICLE SWIPES ",
            type: "SwipeTimings"
          },
          {
            uid: "assignedSwipes",
            name: "ASSIGNED VEHICLE SWIPES",
            type: "SwipeTimings"
          }
        ],
        activeColumns: ["date", "studentName", "admissionNo"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ],
        headerSidebar: [
          {
            type: "card",
            api_url: [""],
            menu: "wrongSwipesHeader",
            sidebarHeading: ""
          }
        ]
      }
    ]
  },
  {
    header: "Campus Attendance Reports",
    description: "",
    order: 3,
    menus: [
      {
        icon: "",
        menu: "Overview",
        menu_description:
          "Overview logs campus attendance via UHF/biometric swipes with user identity",
        url: "/api/nextApi/attendanceReport/campusAttendace",
        method: "POST",
        filters: ["date"],
        innerFilters: [
          {
            uid: "source",
            label: "Source",
            type: "selectBoxSingle",
            options: [
              {id: "0", name: "All"},
              {id: "1", name: "Biometric"},
              {id: "2", name: "UHF"}
            ],
            defaultValue: "0"
          },
          {
            uid: "userType",
            label: "User Type",
            type: "selectBoxSingle",
            options: [
              {id: "1", name: "Student"},
              {id: "2", name: "Staff"}
            ],
            defaultValue: "1"
          }
        ],
        columns: [
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "uhfId",
            name: "UHF ID",
            type: "String"
          },
          {
            uid: "biometricId",
            name: "BIOMETRIC ID",
            type: "String"
          }
        ],
        activeColumns: [
          "name",
          "studentClass",
          "studentSection",
          "admissionNo"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          // CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "User Swipes (UHF & Biometric)",
        menu_description:
          "Logs campus attendance via UHF/biometric swipes with user identity, timing, and entry/exit tracking.",
        url: "/api/reports/campusAttendance/v2",
        method: "POST",
        filters: ["date"],
        innerFilters: [
          {
            uid: "source",
            label: "Source",
            type: "selectBoxSingle",
            options: [
              {id: "0", name: "All"},
              {id: "1", name: "Biometric"},
              {id: "2", name: "UHF"}
            ],
            defaultValue: "0"
          },
          {
            uid: "userType",
            label: "User Type",
            type: "selectBoxSingle",
            options: [
              {id: "1", name: "Student"},
              {id: "2", name: "Staff"}
            ],
            defaultValue: "1"
          }
        ],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "uhfId",
            name: "UHF ID",
            type: "String"
          },
          {
            uid: "biometricId",
            name: "BIOMETRIC ID",
            type: "String"
          },
          {
            uid: "batchStartTime",
            name: "BATCH START TIME",
            type: "Datetime"
          },
          {
            uid: "batchEndTime",
            name: "BATCH END TME",
            type: "Datetime"
          },
          {
            uid: "in",
            name: "IN",
            type: "Time"
          },
          {
            uid: "out",
            name: "OUT",
            type: "Time"
          },
          {
            uid: "otherSwipes",
            name: "OTHER SWIPES",
            type: "Time"
          }
        ],
        activeColumns: [
          "date",
          "name",
          "admissionNo",
          "studentClass",
          "studentSection",
          "uhfId",
          "biometricId",
          "batchStartTime",
          "batchEndTime",
          "in",
          "out",
          "otherSwipes"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          //CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "Canteen Report",
        menu_description:
          "Monitors canteen access using UHF swipe data, capturing canteen timings, eligibility status, etc.",
        url: "/api/reports/canteen/v2",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "uhfId",
            name: "UHF CARD NO",
            type: "String"
          },
          {
            uid: "breakfastInTime",
            name: "BREAKFAST IN TIME",
            type: "Time"
          },
          {
            uid: "breakfastOutTime",
            name: "BREAKFAST OUT TIME",
            type: "Time"
          },
          {
            uid: "lunchInTime",
            name: "LUNCH IN TIME",
            type: "Time"
          },
          {
            uid: "lunchOutTime",
            name: "LUNCH OUT TIME",
            type: "Time"
          },
          {
            uid: "isOpted",
            name: "IS OPTED",
            type: "String"
          },
          {
            uid: "payment",
            name: "PAYMENT",
            type: "String"
          },
          {
            uid: "validityStartDate",
            name: "VALIDITY START DATE",
            type: "Datetime"
          },
          {
            uid: "validityEndDate",
            name: "VALIDITY END DATE",
            type: "Datetime"
          },
          {
            uid: "isAuthorized",
            name: "IS AUTHORISED",
            type: "String"
          }
        ],
        activeColumns: [
          "date",
          "name",
          "admissionNo",
          "studentClass",
          "studentSection",
          "uhfId",
          "breakfastInTime",
          "breakfastOutTime",
          "lunchInTime",
          "lunchOutTime",
          "isOpted",
          "payment",
          "validityStartDate",
          "validityEndDate",
          "isAuthorized"
        ],
        headerSidebar: [
          {
            type: "card",
            api_url: [""],
            menu: "uhfCanteenHeader",
            sidebarHeading: ""
          }
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          // CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "Gate Attendance",
        menu_description:
          "The report related to a system that monitors or tracks the pickup activities of a guardian or a designated person.",
        url: "/api/reports/gateAttendance",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "entryTime",
            name: "ENTRY TIME",
            type: "Time"
          },
          {
            uid: "exitTime",
            name: "EXIT TIME",
            type: "Time"
          },
          {
            uid: "guardianName",
            name: "GUARDIAN NAME",
            type: "String"
          }
        ],
        activeColumns: [
          "date",
          "name",
          "studentClass",
          "studentSection",
          "admissionNo",
          "entryTime",
          "exitTime",
          "guardianName"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          //CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      }
    ]
  },
  {
    header: "Log Reports",
    description: "",
    order: 2,
    menus: [
      {
        icon: "",
        menu: "Travel Log",
        menu_description:
          " Comprehensive record of all vehicle journeys, capturing start/end locations, timestamps, Avg.speed and distances traveled.",
        url: "/api/reports/travelLog/v2",
        method: "POST",
        filters: ["date", "vehicleSingle"],
        columns: [
          {
            uid: "vehicleName",
            name: "Vehicle Name"
          },
          {
            uid: "from",
            name: "From"
          },
          {
            uid: "to",
            name: "To"
          },
          {
            uid: "time",
            name: "Time"
          },
          {
            uid: "tripCompletedTime",
            name: "Trip type"
          },
          {
            uid: "avgSpeed",
            name: "Avg.Speed"
          },
          {
            uid: "distance",
            name: "Distance"
          },
          {
            uid: "location",
            name: "Location"
          }
        ],
        activeColumns: ["vehicleName", "from", "to"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE,
          CustomerType.SME
        ]
      },
      // {
      //   icon: "",
      //   menu: "RFID",
      //   menu_description:
      //     "This report helps in tracking vehicle activity and ensuring that RFID swipes are correctly assigned ",
      //   url: "/api/node/log/rfid",
      //   method: "POST",
      //   filters: ["date"],
      //   columns: [
      //     {
      //       uid: "vehicleName",
      //       name: "Vehicle"
      //     },
      //     {
      //       uid: "totalSwipe",
      //       name: "Total Swipe"
      //     },
      //     {
      //       uid: "assignedswipedCount",
      //       name: "Assigned Count"
      //     },
      //     {
      //       uid: "unAssignedswipedCount",
      //       name: "Un Assigned Count"
      //     }
      //   ],
      //   sideBar: [
      //     {
      //       type: "card",
      //       api_url: "/api/node/log/rfid",
      //       menu: "rfidLog",
      //       sidebarHeading: ""
      //     }
      //   ],
      //   activeColumns: [
      //     "vehicleName",
      //     "totalSwipe",
      //     "assignedswipedCount",
      //     "unAssignedswipedCount"
      //   ]
      // },
      // {
      //   icon: "",
      //   menu: "UHF",
      //   menu_description:
      //     "This report helps in tracking vehicle activity and ensuring that RFID swipes are correctly assigned ",
      //   url: "/api/node/log/uhf",
      //   method: "POST",
      //   filters: ["date"],
      //   columns: [
      //     {
      //       uid: "ip_address",
      //       name: "IP Address"
      //     },
      //     {
      //       uid: "uhfTotalSwipe",
      //       name: "Total Swipe"
      //     },
      //     {
      //       uid: "uhfAssignedSwipe",
      //       name: "Assigned Count"
      //     },
      //     {
      //       uid: "uhfUnAssigned",
      //       name: "Un Assigned Count"
      //     }
      //   ],
      //   activeColumns: [
      //     "ip_address",
      //     "uhfTotalSwipe",
      //     "uhfAssignedSwipe",
      //     "uhfUnAssigned"
      //   ]
      // },
      {
        icon: "",
        menu: "User Histories",
        menu_description:
          "Chronological records of individual user interactions and activities within the system, capturing patterns of engagement and usage over time.",
        url: "/api/reports/user/histories/v2",
        method: "POST",
        filters: [],
        columns: [
          {
            uid: "userName",
            name: "User Name"
          },
          {
            uid: "name",
            name: "Student Name"
          },
          {
            uid: "phone",
            name: "Phone Number"
          },
          {
            uid: "email",
            name: "Email"
          },
          {
            uid: "parentName",
            name: "Parent Name"
          },
          {
            uid: "userClass",
            name: "Class"
          },
          {
            uid: "section",
            name: "Section"
          },
          {
            uid: "uniqueId",
            name: "Stud ID"
          },
          {
            uid: "operation",
            name: "Operation"
          },
          {
            uid: "dateTime",
            name: "Date - Time"
          },
          {
            uid: "updatedBy",
            name: "Updated By"
          }
        ],
        activeColumns: ["userName", "name", "Phone"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "User Credentials",
        menu_description:
          "Authentication information that verifies identity and grants appropriate system access, typically consisting of usernames and passwords or other verification factors.",
        url: "/api/reports/user/credentials/v2",
        method: "POST",
        filters: [],
        columns: [
          {
            uid: "userName",
            name: "User Name"
          },
          {
            uid: "phoneNumber",
            name: "Phone Number"
          },
          {
            uid: "message",
            name: "Message"
          },
          {
            uid: "enrollmentId",
            name: "Enrollment Id"
          }
        ],
        activeColumns: ["userName", "enrollmentId", "phoneNumber", "message"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "Capacity Utilization",
        menu_description:
          "Analyzes vehicle usage efficiency by tracking user counts and trip-type distribution per route.",
        url: "/api/reports/capacityUtilization/v2",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "vehicleName",
            name: "VEHICLE",
            type: "String"
          },
          {
            uid: "route",
            name: "ROUTE",
            type: "String"
          },
          {
            uid: "tripType",
            name: "TRIP TYPE",
            type: "String"
          },
          {
            uid: "total",
            name: "TOTAL USERS",
            type: "Number"
          },
          {
            uid: "pick",
            name: "PICK USERS",
            type: "Number"
          },
          {
            uid: "pickPercentage",
            name: "PICK %",
            type: "Number"
          },
          {
            uid: "drop",
            name: "DROP USERS",
            type: "Number"
          },
          {
            uid: "dropPercentage",
            name: "DROP %",
            type: "Number"
          }
        ],
        activeColumns: ["date", "vehicleName", "route", "total"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "Speed Breach",
        menu_description:
          "Records speed violations per vehicle to monitor and enforce safe driving behavior.",
        url: "/api/reports/speedBreach/v2",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "vehicleName",
            name: "VEHICLE",
            type: "String"
          },
          {
            uid: "count",
            name: "COUNT",
            type: "Number"
          }
        ],
        activeColumns: ["date", "vehicleName", "count"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "UHF Records",
        menu_description:
          "Records student scan data with UHF RFID, including date, location, and basic student info for tracking.",
        url: "/api/reports/uhfRecord/v2",
        method: "",
        filters: ["date", "uhfGroup"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Date"
          },
          {
            uid: "uhfId",
            name: "UHF ID",
            type: "String"
          },
          {
            uid: "locationId",
            name: "LOCATION ID",
            type: "String"
          },
          {
            uid: "name",
            name: "NAME",
            type: "String"
          },
          {
            uid: "studentClass",
            name: "CLASS",
            type: "String"
          },
          {
            uid: "studentSection",
            name: "SECTION",
            type: "String"
          },
          {
            uid: "admissionNo",
            name: "ADMISSION NO",
            type: "String"
          },
          {
            uid: "schoolGroup",
            name: "SCHOOL GROUP",
            type: "String"
          },
          {
            uid: "code",
            name: "CODE",
            type: "String"
          },
          {
            uid: "batch",
            name: "BATCH",
            type: "String"
          },
          {
            uid: "grNo",
            name: "GR NO",
            type: "String"
          }
        ],
        activeColumns: ["date", "uhfId", "locationId", "name", "studentClass"],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          //CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      }
    ]
  },
  {
    header: "Alert Reports",
    description: "",
    order: 3,
    menus: [
      {
        icon: "",
        menu: "Notification",
        menu_description:
          "The Notifications report provides an overview of all notifications within the system, and can be used to monitor system activity during periods of load.",
        url: "/api/reports/notifications/v2",
        method: "post",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "Date"
          },
          {
            uid: "name",
            name: "Name"
          },
          {
            uid: "enrollNo",
            name: "Enroll NO"
          },
          {
            uid: "className",
            name: "Class"
          },
          {
            uid: "sectionName",
            name: "Section"
          },
          {
            uid: "uhfId",
            name: "UHF Id"
          },
          {
            uid: "msg",
            name: "Notification Content"
          }
        ],
        activeColumns: [
          "date",
          "name",
          "enrollNo",
          "className",
          "sectionName",
          "uhfId",
          "msg"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "Announcement History",
        menu_description:
          "The Notifications report provides an overview of all notifications within the system, and can be used to monitor system activity during periods of load.",
        url: "/api/reports/announcements/v2",
        method: "post",
        filters: ["date"],
        columns: [
          {
            uid: "time",
            name: "DATE",
            type: "Datetime"
          },
          {
            uid: "vehicleName",
            name: "VEHICLE",
            type: "String"
          },
          {
            uid: "route",
            name: "ROUTE",
            type: "String"
          },
          {
            uid: "msg",
            name: "MESSAGE",
            type: "String"
          },
          {
            uid: "userCount",
            name: "USER COUNT",
            type: "Number"
          },
          {
            uid: "notificationCount",
            name: "NOTIFICATION COUNT",
            type: "Number"
          },
          {
            uid: "smsCount",
            name: "SMS COUNT",
            type: "Number"
          }
        ],
        activeColumns: [
          "time",
          "vehicleName",
          "route",
          "msg",
          "userCount",
          "notificationCount",
          "smsCount"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      }
    ]
  },
  // Hardware status start
  {
    header: "Hardware Status Reports",
    description: "",
    order: 5,
    menus: [
      {
        icon: "",
        menu: "Biometric",
        menu_description:
          "This report helps you see which fingerprint or face recognition devices are active and which require maintenance.",
        url: "/api/reports/biometric/status/v2?loginUserId=",
        method: "post",
        filters: [],
        columns: [
          {
            uid: "deviceName",
            name: "NAME",
            type: "String"
          },
          {
            uid: "serialNo",
            name: "SERIAL NO",
            type: "String"
          },
          {
            uid: "lastLogTime",
            name: "LAST LOG TIME",
            type: "Datetime"
          },
          {
            uid: "location",
            name: "LOCATION",
            type: "String"
          },
          {
            uid: "status",
            name: "STATUS",
            type: "String"
          }
        ],
        activeColumns: [
          "deviceName",
          "serialNo",
          "lastLogTime",
          "location",
          "status"
        ],
        headerSidebar: [
          {
            type: "card",
            api_url: [""],
            menu: "hardwareReportBioMetr",
            sidebarHeading: ""
          }
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "UHF",
        menu_description:
          "This report helps you see which long-range RFID scanners (UHF) are working properly and which ones may need attention.",
        url: "/api/reports/uhf/status/v2?loginUserId=",
        method: "post",
        filters: [],
        columns: [
          {
            uid: "ip",
            name: "IP",
            type: "String"
          },
          {
            uid: "lastLogTime",
            name: "LAST LOG TIME",
            type: "Datetime"
          },
          {
            uid: "location",
            name: "LOCATION",
            type: "String"
          },
          {
            uid: "status",
            name: "STATUS",
            type: "String"
          }
        ],
        activeColumns: ["ip", "lastLogTime", "location", "status"],
        headerSidebar: [
          {
            type: "card",
            api_url: [""],
            menu: "hardwareReportBioMetr",
            sidebarHeading: ""
          }
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      }
    ]
  },
  // Hardware status end

  // Fuel Report start
  {
    header: "Fuel Reports",
    description: "",
    order: 6,
    menus: [
      {
        icon: "",
        menu: "Fuel Consumption",
        menu_description:
          "Identifies and categorizes invalid or mismatched RFID swipes to detect configuration or usage errors.",
        url: "/api/reports/fuel/consolidate",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "vehicleId",
            name: "Vehicle",
            type: "String"
          },
          {
            uid: "date",
            name: "DATE",
            type: "Datetime"
          },
          {
            uid: "startfuel",
            name: "Start Fuel (L)",
            type: "String"
          },
          {
            uid: "endfuel",
            name: "End Fuel (L)",
            type: "String"
          },
          {
            uid: "distance",
            name: "Distance (KM)",
            type: "String"
          },
          {
            uid: "fuelconsumed",
            name: "Fuel Consumed (L)",
            type: "String"
          },
          {
            uid: "mileage",
            name: "Mileage (KM/L)",
            type: "String"
          },
          {
            uid: "fuelfill",
            name: "Fuel Fill",
            type: "String"
          },
          {
            uid: "fueltheft",
            name: "Fuel Theft",
            type: "String"
          }
        ],
        activeColumns: [
          "vehicleId",
          "date",
          "startfuel",
          "endfuel",
          "distance",
          "fuelconsumed",
          "mileage",
          "fuelfill",
          "fueltheft"
        ],
        headerSidebar: [],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      },
      {
        icon: "",
        menu: "Fuel Analytics",
        menu_description:
          "Provides detailed insights into fuel usage patterns, helping optimize consumption and reduce costs.",
        url: "/api/reports/fuel/singleVehicle",
        method: "POST",
        filters: ["date"],
        columns: [
          {
            uid: "date",
            name: "DATE",
            type: "Datetime"
          },
          {
            uid: "fuelType",
            name: "TYPE",
            type: "String"
          },
          {
            uid: "prevFuel",
            name: "PREV FUEL (L)",
            type: "Number"
          },
          {
            uid: "currentFuel",
            name: "CURRENT FUEL (L)",
            type: "Number"
          },
          {
            uid: "fuel",
            name: "FUEL (L)",
            type: "Number"
          },
          {
            uid: "location",
            name: "LOCATION",
            type: "Locations"
          }
        ],
        activeColumns: [
          "date",
          "fuelType",
          "prevFuel",
          "currentFuel",
          "fuel",
          "location"
        ],
        acceptCustomerType: [
          CustomerType.SCHOOL,
          CustomerType.EMPLOYEETRACKING,
          CustomerType.INDIVIDUAL,
          CustomerType.COLLEGE
        ]
      }
    ]
  }
  // Fuel Report end
  // new work
  // {
  //   header: "Employee Transportation Reports",
  //   description: "",
  //   order: 3,
  //   menus: [
  //     {
  //       icon: "",
  //       menu: "Time Driven",
  //       menu_description:
  //         "Tracks the total driving time per employee to support shift analysis, payroll accuracy, and productivity insights.",
  //       url: "/api/reports/travelLog/v2",
  //       method: "POST",
  //       filters: ["date", "vehicleSingle"],
  //       columns: [
  //         {
  //           uid: "vehicleName",
  //           name: "Vehicle Name"
  //         },
  //         {
  //           uid: "from",
  //           name: "From"
  //         },
  //         {
  //           uid: "to",
  //           name: "To"
  //         },
  //         {
  //           uid: "time",
  //           name: "Time"
  //         },
  //         {
  //           uid: "tripCompletedTime",
  //           name: "Trip type"
  //         },
  //         {
  //           uid: "avgSpeed",
  //           name: "Avg.Speed"
  //         },
  //         {
  //           uid: "distance",
  //           name: "Distance"
  //         },
  //         {
  //           uid: "location",
  //           name: "Location"
  //         }
  //       ],
  //       activeColumns: ["vehicleName", "from", "to"],
  //       // should add headerTopBar here

  //       headerSidebar: [
  //         {
  //           type: "card",
  //           api_url: [""],
  //           menu: "nokiaTimeDriven",
  //           sidebarHeading: ""
  //         }
  //       ],
  //       acceptCustomerType: [
  //         CustomerType.SCHOOL,
  //         CustomerType.EMPLOYEETRACKING,
  //         CustomerType.INDIVIDUAL,
  //         CustomerType.COLLEGE,
  //         CustomerType.SME
  //       ]
  //     },
  //     {
  //       icon: "",
  //       menu: "Sudden Acceleration",
  //       menu_description:
  //         "Tracks the total driving time per employee to support shift analysis, payroll accuracy, and productivity insights.",
  //       url: "/api/reports/travelLog/v2",
  //       method: "POST",
  //       filters: ["date", "vehicleSingle"],
  //       columns: [
  //         {
  //           uid: "vehicleName",
  //           name: "Vehicle Name"
  //         },
  //         {
  //           uid: "from",
  //           name: "From"
  //         },
  //         {
  //           uid: "to",
  //           name: "To"
  //         },
  //         {
  //           uid: "time",
  //           name: "Time"
  //         },
  //         {
  //           uid: "tripCompletedTime",
  //           name: "Trip type"
  //         },
  //         {
  //           uid: "avgSpeed",
  //           name: "Avg.Speed"
  //         },
  //         {
  //           uid: "distance",
  //           name: "Distance"
  //         },
  //         {
  //           uid: "location",
  //           name: "Location"
  //         }
  //       ],
  //       activeColumns: ["vehicleName", "from", "to"],
  //       // topbar
  //       headerSidebar: [
  //         {
  //           type: "card",
  //           api_url: [""],
  //           menu: "nokiaSuddenAcceleration",
  //           sidebarHeading: ""
  //         }
  //       ],
  //       acceptCustomerType: [
  //         CustomerType.SCHOOL,
  //         CustomerType.EMPLOYEETRACKING,
  //         CustomerType.INDIVIDUAL,
  //         CustomerType.COLLEGE,
  //         CustomerType.SME
  //       ]
  //     },
  //     {
  //       icon: "",
  //       menu: "Safety Risk Report",
  //       menu_description:
  //         " Detects mismatches between assigned and actual pickup or drop swipes to ensure trip accuracy and compliance.",
  //       url: "/api/reports/travelLog/v2",
  //       method: "POST",
  //       filters: ["date", "vehicleSingle"],
  //       columns: [
  //         {
  //           uid: "vehicleName",
  //           name: "Vehicle Name"
  //         },
  //         {
  //           uid: "from",
  //           name: "From"
  //         },
  //         {
  //           uid: "to",
  //           name: "To"
  //         },
  //         {
  //           uid: "time",
  //           name: "Time"
  //         },
  //         {
  //           uid: "tripCompletedTime",
  //           name: "Trip type"
  //         },
  //         {
  //           uid: "avgSpeed",
  //           name: "Avg.Speed"
  //         },
  //         {
  //           uid: "distance",
  //           name: "Distance"
  //         },
  //         {
  //           uid: "location",
  //           name: "Location"
  //         }
  //       ],
  //       activeColumns: ["vehicleName", "from", "to"],
  //       headerSidebar: [
  //         {
  //           type: "card",
  //           api_url: [""],
  //           menu: "nokiaSafetyRisk",
  //           sidebarHeading: ""
  //         }
  //       ],
  //       acceptCustomerType: [
  //         CustomerType.SCHOOL,
  //         CustomerType.EMPLOYEETRACKING,
  //         CustomerType.INDIVIDUAL,
  //         CustomerType.COLLEGE,
  //         CustomerType.SME
  //       ]
  //     },
  //     {
  //       icon: "",
  //       menu: "Over speed",
  //       menu_description:
  //         "Monitors adherence to assigned routes, schedules, and transportation policies for each employee.",
  //       url: "/api/reports/travelLog/v2",
  //       method: "POST",
  //       filters: ["date", "vehicleSingle"],
  //       columns: [
  //         {
  //           uid: "vehicleName",
  //           name: "Vehicle Name"
  //         },
  //         {
  //           uid: "from",
  //           name: "From"
  //         },
  //         {
  //           uid: "to",
  //           name: "To"
  //         },
  //         {
  //           uid: "time",
  //           name: "Time"
  //         },
  //         {
  //           uid: "tripCompletedTime",
  //           name: "Trip type"
  //         },
  //         {
  //           uid: "avgSpeed",
  //           name: "Avg.Speed"
  //         },
  //         {
  //           uid: "distance",
  //           name: "Distance"
  //         },
  //         {
  //           uid: "location",
  //           name: "Location"
  //         }
  //       ],
  //       activeColumns: ["vehicleName", "from", "to"],
  //       acceptCustomerType: [
  //         CustomerType.SCHOOL,
  //         CustomerType.EMPLOYEETRACKING,
  //         CustomerType.INDIVIDUAL,
  //         CustomerType.COLLEGE,
  //         CustomerType.SME
  //       ]
  //     },
  //     {
  //       icon: "",
  //       menu: "Distance Deviation",
  //       menu_description:
  //         "Detects mismatches between assigned and actual pickup or drop swipes to ensure trip accuracy and compliance.",
  //       url: "/api/reports/travelLog/v2",
  //       method: "POST",
  //       filters: ["date", "vehicleSingle"],
  //       columns: [
  //         {
  //           uid: "vehicleName",
  //           name: "Vehicle Name"
  //         },
  //         {
  //           uid: "from",
  //           name: "From"
  //         },
  //         {
  //           uid: "to",
  //           name: "To"
  //         },
  //         {
  //           uid: "time",
  //           name: "Time"
  //         },
  //         {
  //           uid: "tripCompletedTime",
  //           name: "Trip type"
  //         },
  //         {
  //           uid: "avgSpeed",
  //           name: "Avg.Speed"
  //         },
  //         {
  //           uid: "distance",
  //           name: "Distance"
  //         },
  //         {
  //           uid: "location",
  //           name: "Location"
  //         }
  //       ],
  //       activeColumns: ["vehicleName", "from", "to"],
  //       acceptCustomerType: [
  //         CustomerType.SCHOOL,
  //         CustomerType.EMPLOYEETRACKING,
  //         CustomerType.INDIVIDUAL,
  //         CustomerType.COLLEGE,
  //         CustomerType.SME
  //       ]
  //     },
  //     {
  //       icon: "",
  //       menu: "Harsh Braking",
  //       menu_description:
  //         " Tracks instances where drivers apply brakes abruptly beyond safe thresholds, helping identify risky driving patterns and improve road safety.",
  //       url: "/api/reports/travelLog/v2",
  //       method: "POST",
  //       filters: ["date", "vehicleSingle"],
  //       columns: [
  //         {
  //           uid: "vehicleName",
  //           name: "Vehicle Name"
  //         },
  //         {
  //           uid: "from",
  //           name: "From"
  //         },
  //         {
  //           uid: "to",
  //           name: "To"
  //         },
  //         {
  //           uid: "time",
  //           name: "Time"
  //         },
  //         {
  //           uid: "tripCompletedTime",
  //           name: "Trip type"
  //         },
  //         {
  //           uid: "avgSpeed",
  //           name: "Avg.Speed"
  //         },
  //         {
  //           uid: "distance",
  //           name: "Distance"
  //         },
  //         {
  //           uid: "location",
  //           name: "Location"
  //         }
  //       ],
  //       activeColumns: ["vehicleName", "from", "to"],
  //       acceptCustomerType: [
  //         CustomerType.SCHOOL,
  //         CustomerType.EMPLOYEETRACKING,
  //         CustomerType.INDIVIDUAL,
  //         CustomerType.COLLEGE,
  //         CustomerType.SME
  //       ]
  //     }
  //   ]
  // } // new work end
];
